import { RouteObject } from 'react-router'

import { ROUTES } from '@/common/constants/routes'
import UnauthenticatedLayout from '@/common/layouts/UnauthenticatedLayout'
import ActivateUser from './pages/ActivateUser'
import ForgotPassword from './pages/ForgotPassword'
import NewPassword from './pages/NewPassword'
import SignIn from './pages/SignIn'
import Sso from './pages/Sso'

export const LoginRoutes: RouteObject[] = [
  {
    element: <UnauthenticatedLayout />,
    children: [
      {
        path: ROUTES.LOGIN.SIGN_IN,
        element: <SignIn />,
      },
      {
        path: ROUTES.LOGIN.FORGOT_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: ROUTES.LOGIN.SSO,
        element: <Sso />,
      },
      {
        path: ROUTES.LOGIN.NEW_PASSWORD,
        element: <NewPassword />,
      },
      {
        path: ROUTES.LOGIN.ACTIVATE_USER,
        element: <ActivateUser />,
      },
    ],
  },
]
